import { Pipe, PipeTransform } from '@angular/core';
import { CompanyEnum } from '../enums/company-enum';

@Pipe({
    name: 'companyName',
    standalone: false
})
export class CompanyNamePipe implements PipeTransform {

  transform(companyId: number): string {
    
    switch (companyId) {
      case CompanyEnum.Tot:
        return 'ToT';
      case CompanyEnum.Teach:
        return 'Teach';
      default:
        return '';
    }

  }

}
